const $ = window.$;
export function loadTree() {
    const trees = $('[data-widget="treeview"]');
    trees.Treeview('init');
}

/*export function loadTree() {
    $('[data-widget="treeview"]').each(function () {
        if ($(this).data('treeview-init') === undefined) {
            $(this).Treeview('init');
            $(this).data('treeview-init', true);
        }
    });
}*/
